import React from "react";
import Fade from "@material-ui/core/Fade";

export default function MainAnimation({ children }) {
  return <Fade in>{children}</Fade>;
}
